export default "/images/topdanmark.avif?44ba9dd248f1028f43f07b3706f4c4cd";